export const INVOICE_DATE_COLUMNS = ['thisMonth', 'thisWeek', 'today', 'delayed', 'completed'] as const;
export type InvoiceDateColumn = typeof INVOICE_DATE_COLUMNS[number];

export function invoicePaymentDate(value: string): Date | null {
  const match = /^(\d{4})-(\d{2})-(\d{2})(?:$|[T ])/.exec(value || '');
  if (!match) return null;
  const [year, month, day] = match.slice(1).map(Number);
  const date = new Date(year, month - 1, day);
  return date.getFullYear() === year && date.getMonth() === month - 1 && date.getDate() === day ? date : null;
}
const calendarDay = (date: Date) => Date.UTC(date.getFullYear(), date.getMonth(), date.getDate()) / 86400000;

/** Exclusive billing columns within the selected payment month. */
export function invoiceDateColumn(paymentDate: string, today = new Date(), selectedMonth?: Date, hasFacturaAttachment = false, invoiceStatus?: string, allMonths = false): InvoiceDateColumn | null {
  if (invoiceStatus === 'canceled') return null;
  const date = invoicePaymentDate(paymentDate);
  if (!date) return null;
  if (selectedMonth && (date.getFullYear() !== selectedMonth.getFullYear() || date.getMonth() !== selectedMonth.getMonth())) return null;
  if (hasFacturaAttachment) return 'completed';
  const day = calendarDay(date);
  const currentDay = calendarDay(today);
  if (day < currentDay) return 'delayed';
  if (day === currentDay) return 'today';
  const monday = currentDay - (today.getDay() + 6) % 7;
  if (day >= monday && day <= monday + 6) return 'thisWeek';
  const month = selectedMonth ?? today;
  if (date.getFullYear() === month.getFullYear() && date.getMonth() === month.getMonth()) return 'thisMonth';
  return allMonths ? 'thisMonth' : null;
}
